import React, { useState } from "react";
import axios from "axios";
import { Badge, Col, Container, Row } from "reactstrap";
import { getCookie } from "../../helpers/cookie";
import { useNavigate } from "react-router-dom";

const Getwithai = () => {
    const token = getCookie('access_token');
  const [aiDescription, setAiDescription] = useState("");
  const [Description, setDescription] = useState("");
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [reloader, setReloader] = useState(false);
  const [error, setError] = useState("");
  const [showProjectDetails, setShowProjectDetails] = useState(false);
  const [showscreen3, setShowscreen3] = useState(false);
  const [ProjectStartDate, setProjectStartDate] = useState("");
  const [ProjectEndDate, setProjectEndDate] = useState("");
  const [stageDescription, setStageDescription] = useState("");
  const [stagesview, setStagesview] = useState(false);
  const [stagesData, setStagesData] = useState(null);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [selectedStageName, setSelectedStageName] = useState("");
  const [members, setMembers] = useState([{ role: "", experience: "" }]);
  const [localStages, setLocalStages] = useState(stagesData?.stages || []);
  const [teamSizes, setTeamSizes] = useState({});
  const [savedStages, setSavedStages] = useState([]);
const handleSaveStages = async () => {
  const payload = {
    project_name: stagesData?.project_name,
    description: stagesData?.description,
    ...(ProjectStartDate && { start_date: ProjectStartDate }),
      ...(ProjectEndDate && { end_date: ProjectEndDate }),
    stages: stagesData?.stages?.map(stage => ({
      stage_name: stage.stage_name,
      description: stage.description,
      team_size: teamSizes[stage.stage_id] || 0
    }))
  };

  try {
      const res = await axios.post(
        "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/project-create/",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      // setStagesview(false);
      const raw = res?.data?.data;
      if (!raw) throw new Error("Empty AI response");

      let parsed;
      try {
        parsed = JSON.parse(cleanAIJson(raw));
      } catch (e) {
        console.error("JSON PARSE ERROR:", e);
        console.error("RAW DATA:", raw);
        setError("AI returned invalid data format");
        return;
      }

      // UI-only flag for collapse
      parsed.stages = parsed.stages.map((s) => ({
        ...s,
        open: true,
      }));

      setFormData(parsed);
      console.log(parsed,'parsed');
      
      setShowProjectDetails(true);
      setDescription(parsed.description);
    } catch (err) {
      console.error("API ERROR:", err);
      setError("Failed to get AI data");
    } finally {
      setLoading(false);
    }
};

const handleCancelStages = () => {
  setTeamSizes({});
  setStagesview(false);
};

  const handleMemberChange = (index, field, value) => {
    const updated = [...members];
    updated[index][field] = value;
    setMembers(updated);
  };

  const handleRemoveMember = (index) => {
    if (members.length === 1) return;
    setMembers(members.filter((_, i) => i !== index));
  };
const handleSaveTeam = () => {
  const updatedStages = localStages.map(stage => {
    if (stage.id === selectedStageName.id) {
      return {
        ...stage,
        members: members
      };
    }
    return stage;
  });

  setLocalStages(updatedStages);
  setShowTeamModal(false);
};
const getStageMembersByName = (stageName) => {
  return localStages.find(stage => stage.stage_name === stageName)?.members || [];
};

  const navigate = useNavigate();
const resetForm = () => {
  setAiDescription("");
  setFormData(null);
  setShowProjectDetails(false);
  setProjectStartDate("");
  setProjectEndDate("");
  setError("");

};
  const cleanAIJson = (raw) => {
    return raw
      .replace(/""estimated_hours"/g, '"estimated_hours"')
      .replace(/\\&/g, "&");
  };

  const handleGetWithAI = async () => {
    if (!aiDescription.trim()) {
      setError("Project description is required");
      return;
    }

    setLoading(true);
    setError("");
    setFormData(null);
    let payload = {
      project_description: aiDescription,
      ...(ProjectStartDate && { start_date: ProjectStartDate }),
      ...(ProjectEndDate && { end_date: ProjectEndDate }),
    };

    try {
      const res = await axios.post(
        "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/project-create-old/",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const raw = res?.data?.data;
      if (!raw) throw new Error("Empty AI response");

      let parsed;
      try {
        parsed = JSON.parse(cleanAIJson(raw));
      } catch (e) {
        console.error("JSON PARSE ERROR:", e);
        console.error("RAW DATA:", raw);
        setError("AI returned invalid data format");
        return;
      }

      // UI-only flag for collapse
      parsed.stages = parsed.stages.map((s) => ({
        ...s,
        open: true,
      }));

      setFormData(parsed);
      console.log(parsed,'parsed');
      setStagesview(true);
      setShowProjectDetails(true);
      setDescription(parsed.description);
    } catch (err) {
      console.error("API ERROR:", err);
      setError("Failed to get AI data");
    } finally {
      setLoading(false);
    }
  };
  const handleReGenerate = async () => {
    if (!Description.trim()) {
      setError("Project description is required");
      return;
    }
    setAiDescription(Description);
    setReloader(true);
    setError("");
    let payload = {
      project_description: Description,
      ...(ProjectStartDate && { start_date: ProjectStartDate }),
      ...(ProjectEndDate && { end_date: ProjectEndDate }),
    };

    try {
      const res = await axios.post(
        "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/project-create/",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const raw = res?.data?.data;
      if (!raw) throw new Error("Empty AI response");

      let parsed;
      try {
        parsed = JSON.parse(cleanAIJson(raw));
      } catch (e) {
        console.error("JSON PARSE ERROR:", e);
        console.error("RAW DATA:", raw);
        setError("AI returned invalid data format");
        return;
      }
      parsed.stages = parsed.stages.map((s) => ({
        ...s,
        open: true,
      }));

      setFormData(parsed);
      setDescription(parsed?.description);
      setStagesview(false);
    } catch (err) {
      setError("Failed to get AI data");
    } finally {
      setReloader(false);
    }
  };
  const handleAiSuggestion2 = async () => {
  if (!aiDescription.trim()) {
    setError("Project description is required");
    return;
  }
  try {
    setAiLoading(true);
    setError("");
  const response = await axios.post(
    "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/refine-content/",
    { content: aiDescription },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  console.log("AI Suggestion Response:", response);
  const suggestion = response?.data?.refined_content;
  setAiDescription(suggestion);
  setAiLoading(false);
  setError("");
} catch (err) {
  console.error("AI Suggestion Error:", err);
  setError("Failed to get AI suggestion");
}
}
const handleAiSuggestion = async () => {
  // if (!aiDescription.trim()) {
  //   setError("Project description is required");
  //   return;
  // }
  try {
    setAiLoading(true);
    setError("");
  const response = await axios.post(
    "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/refine-content/",
    { content: stageDescription },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  console.log("AI Suggestion Response:", response);
  const suggestion = response?.data?.refined_content;
  // setAiDescription(suggestion);
  setStageDescription(suggestion);
  setAiLoading(false);
  setError("");
} catch (err) {
  console.error("AI Suggestion Error:", err);
  setError("Failed to get AI suggestion");
}
}
const handlestages = async () => {
  if (!stageDescription.trim()) {
    setError("Project description is required");
    return;
  }
  try {
    setAiLoading(true);
    setError("");
  const response = await axios.post(
    "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/stages-create/",
    { project_description: stageDescription },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  const raw = response?.data?.data;
      if (!raw) throw new Error("Empty AI response");
  let parsed;
      try {
        parsed = JSON.parse(cleanAIJson(raw));
      } catch (e) {
        console.error("JSON PARSE ERROR:", e);
        console.error("RAW DATA:", raw);
        setError("AI returned invalid data format");
        return;
      }

      // UI-only flag for collapse
      parsed.stages = parsed.stages.map((s) => ({
        ...s,
        open: true,
      }));

      setStagesData(parsed);
  const suggestion = response?.data?.refined_content;
  setStageDescription(suggestion);
  setAiLoading(false);
  setError("");
  setStagesview(true);
} catch (err) {
  console.error("AI Suggestion Error:", err);
  setError("Failed to get AI suggestion");
}
}
const handlereAiSuggestion = async () => {
  if (!Description.trim() ) {
    setError("Project description is required");
    return;
  }
  try {
    setAiLoading(true);
    setError("");
  const response = await axios.post(
    "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/refine-content/",
    { content: Description },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  console.log("AI Suggestion Response:", response);
  const suggestion = response?.data?.refined_content;
  setDescription(suggestion);
  setAiLoading(false);
  setError("");
} catch (err) {
  console.error("AI Suggestion Error:", err);
  setError("Failed to get AI suggestion");
}
}
const [saving, setSaving] = useState(false);

const handleSaveProject = async () => {
  try {
    setSaving(true);
    setError("");

    // Basic validation
    if (!formData?.project_name) {
      setError("Project name is required");
      setSaving(false);
      return;
    }

    const payload = {
      project_name: formData.project_name,
      ai_project_description: aiDescription,
      description: formData.description,
      start_date: formData.start_date,
      end_date: formData.end_date,
      stages: formData.stages.map(stage => ({
        stage_name: stage.stage_name,
        description: stage.description,
        tasks: stage.tasks.map(task => ({
          task_name: task.task_name,
          start_date: task.start_date,
          end_date: task.end_date,
          estimated_hours: task.estimated_hours
        }))
      }))
    };

    const response = await axios.post(
      "https://wqjp2qmn-8000.inc1.devtunnels.ms/api/aiml/create-ai-project/",
      payload, // ✅ RAW JSON
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json" // ✅ IMPORTANT
        }
      }
    );

    if (response.status === 201 || response.status === 200) {
      console.log("Project saved successfully");
      setShowProjectDetails(false);
      navigate('/allactive-project');
      resetForm();
    } else {
      setError(response?.data?.message || "Failed to save project");
    }

  } catch (err) {
    console.error(err);
    setError(
      err?.response?.data?.message ||
      "Something went wrong while saving project"
    );
  } finally {
    setSaving(false);
  }
};


  // ================= UPDATE HANDLERS =================
  const updateField = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const toggleStage = (index) => {
    const stages = [...formData.stages];
    stages[index].open = !stages[index].open;
    setFormData({ ...formData, stages });
  };

  const updateStage = (index, key, value) => {
    const stages = [...formData.stages];
    stages[index][key] = value;
    setFormData({ ...formData, stages });
  };

  const updateTask = (si, ti, key, value) => {
    const stages = [...formData.stages];
    stages[si].tasks[ti][key] = value;
    setFormData({ ...formData, stages });
  };

  // ================= RENDER =================
  return (
    <React.Fragment>
      <Container fluid={true} style={{marginBottom:"60px"}}>
        <div className="page-content page-content.allact-tabs.manager-dash mt-4">
            <Row>
              <Col lg={12}>
                {!showProjectDetails && !stagesview &&(
                  <div
                    style={{
                      minHeight: "80vh",
                      // background: "linear-gradient(180deg, #f3f6ff, #f8f7ff)",
                      padding: "40px 16px",
                    }}
                  >
                    {/* Top Section */}
                    <div style={{ textAlign: "center", marginBottom: "32px" }}>
                      <div
                        style={{
                          width: "56px",
                          height: "56px",
                          margin: "0 auto 14px",
                          borderRadius: "16px",
                          background: "linear-gradient(135deg, #6366f1, #a855f7)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "26px",
                          boxShadow: "0 10px 25px rgba(99,102,241,0.4)",
                        }}
                      >
                        ✨
                      </div>

                      <h1
                        style={{
                          fontSize: "28px",
                          fontWeight: 700,
                          margin: "0 0 8px",
                          color: "#111827",
                        }}
                      >
                        AI Project Generator
                      </h1>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#6b7280",
                          maxWidth: "520px",
                          margin: "0 auto",
                          lineHeight: "1.6",
                        }}
                      >
                        Describe your project and let AI create a complete plan
                      </p>
                    </div>

                    {/* Card */}
                    <div
                      style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        padding: "28px",
                        // boxShadow: "0 14px 35px rgba(0,0,0,0.08)",
                        maxWidth: "760px",
                        margin: "0 auto",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <label
                        style={{
                          display: "block",
                          // fontSize: "14px",
                          // fontWeight: 600,
                          // color: "#1f2937",
                          marginBottom: "10px",
                        }}
                      >
                        Project Description
                      </label>
                    <div style={{ position: "relative" }}>
                      <textarea
                        rows={6}
                        value={aiDescription}
                        onChange={(e) => {setAiDescription(e.target.value);setError("");}}
                        placeholder="Describe your project..."
                        style={{
                          width: "100%",
                          padding: "16px",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                          resize: "none",
                        }}
                        disabled={aiLoading || loading}
                      />
                      <button
                        onClick={handleAiSuggestion2}
                        disabled={aiLoading || loading}
                        style={{
                          position: "absolute",
                          bottom: "12px", right: "12px",
                          height: "32px", padding: "0 14px",
                          borderRadius: "10px", border: "none",
                          background: "linear-gradient(90deg, #8b9cff, #c084fc)",
                          color: "#ffffff", fontSize: "12px",
                          fontWeight: 600, cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.75 : 1, display: "flex", alignItems: "center",
                          gap: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
                        }} > ✨ AI Suggestion </button>
                    </div>
                        {error && (
                          <p style={{ marginTop: "5px", color: "#dc2626", fontSize: "13px" }}>
                            {error}
                          </p>
                        )}
                    <div style={{ display: "flex", gap: "16px" }} className="mt-1">
                      <div style={{ flex: 1 }}>
                        <label>Project Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={ProjectStartDate}
                          min={new Date().toISOString().split("T")[0]}
                          onChange={(e) => {
                            setProjectStartDate(e.target.value);
                            if (ProjectEndDate && e.target.value > ProjectEndDate) {
                              setProjectEndDate("");
                            }
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label>Project End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={ProjectEndDate}
                          min={ProjectStartDate || new Date().toISOString().split("T")[0]}
                          onChange={(e) => setProjectEndDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <button
                        onClick={handleGetWithAI}
                        disabled={aiLoading || loading}
                        style={{
                          marginTop: "22px",
                          width: "100%",
                          height: "45px",
                          borderRadius: "8px",
                          border: "none",
                          background: "linear-gradient(90deg, #9aa9ff, #c89cff)",
                          color: "#ffffff",
                          fontSize: "15px",
                          fontWeight: 600,
                          cursor: loading ? "not-allowed" : "pointer",
                        }}
                      >
                        ✨ {loading ? "Generating..." : "Generate with AI"}
                      </button>
                    </div>
                  </div>
                )}
                {/* Screen 2 - When showProjectDetails is true */}
              {!showProjectDetails && !stagesview &&(
                <div
                  style={{
                    minHeight: "80vh",
                    padding: "40px 16px",
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: "32px" }}>
                    <div
                      style={{
                        width: "56px",
                        height: "56px",
                        margin: "0 auto 14px",
                        borderRadius: "16px",
                        background: "#f3effe",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#6b7280",
                        fontSize: "26px",
                        // boxShadow: "0 10px 25px rgba(99,102,241,0.4)",
                      }}
                    >
                      ✨
                    </div>

                    <h1
                      style={{
                        fontSize: "28px",
                        fontWeight: 700,
                        margin: "0 0 8px",
                        color: "#111827",
                      }}
                    >
                      AI Project Generator
                    </h1>

                    <p
                      style={{
                        fontSize: "15px",
                        color: "#6b7280",
                        maxWidth: "520px",
                        margin: "0 auto",
                        lineHeight: "1.6",
                      }}
                    >
                      Describe your project and let AI create a complete plan
                    </p>
                  </div>

                  {/* Card */}
                  <div
                    style={{
                      borderRadius: "10px",
                      maxWidth: "760px",
                      margin: "0 auto",
                      border: "1px solid #e5e7eb",
                      background: "rgba(255, 255, 255, 0.8)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(0, 0, 0, 0.06)",
                      padding: "40px",
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.06)",
                    }}
                  >
                    <label
                      style={{
                        display: "block",
                        // fontSize: "14px",
                        // fontWeight: 600,
                        // color: "#1f2937",
                        marginBottom: "10px",
                      }}
                    >
                      Project Description s
                    </label>
                    <div style={{ position: "relative" }}>
                      <textarea
                        rows={6}
                        value={stageDescription}
                        onChange={(e) => { setStageDescription(e.target.value); setError(""); }}
                        placeholder="Describe your project..."
                        style={{
                          width: "100%",
                          padding: "16px",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                          resize: "none",
                        }}
                        disabled={aiLoading || loading}
                      />
                    </div>
                    {error && (
                      <p style={{ marginTop: "5px", color: "#dc2626", fontSize: "13px" }}>
                        {error}
                      </p>
                    )}
                    <button
                      onClick={handleAiSuggestion}
                      disabled={aiLoading || loading}
                      style={{
                        marginTop: "10px",
                        padding: "8px 18px",
                        background: "linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.1))",
                        border: "1px solid rgba(99, 102, 241, 0.3)",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#6366f1",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }} > ✨ AI Suggestion </button>
                    <div style={{ display: "flex", gap: "16px" }} className="mt-2">
                      <div style={{ flex: 1 }}>
                        <label>Project Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={ProjectStartDate}
                          min={new Date().toISOString().split("T")[0]}
                          onChange={(e) => {
                            setProjectStartDate(e.target.value);
                            if (ProjectEndDate && e.target.value > ProjectEndDate) {
                              setProjectEndDate("");
                            }
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label>Project End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={ProjectEndDate}
                          min={ProjectStartDate || new Date().toISOString().split("T")[0]}
                          onChange={(e) => setProjectEndDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <button
                      onClick={handlestages}
                      disabled={aiLoading || loading}
                      style={{
                        marginTop: "22px",
                        width: "100%",
                        height: "45px",
                        borderRadius: "8px",
                        border: "none",
                        background: "linear-gradient(135deg, #6366f1, #a855f7)",
                        color: "#ffffff",
                        fontSize: "15px",
                        fontWeight: 600,
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      ✨ {loading ? "Generating..." : "Generate with AI"}
                    </button>
                  </div>
                </div>
              )}




              {/* ================= PROJECT DETAILS ================= */}

              {showProjectDetails && stagesview && (
                <div style={{ backgroundColor: "#f6f8fc", padding: "20px", borderRadius: "13px" }}>
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: "12px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                      padding: "24px",
                      marginBottom: "24px",
                    }}
                  >
                    {/* Header Row */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "16px",
                      }}
                    >
                      {/* Left */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        {/* Icon */}
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #2563eb, #7c3aed)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            fontSize: "18px",
                          }}
                        >
                          ✨
                        </div>

                        {/* Title */}
                        <div>
                          <h1
                            style={{
                              fontSize: "20px",
                              fontWeight: 700,
                              color: "#1e293b",
                              margin: 0,
                            }}
                          >
                            Generated Project Plan
                          </h1>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#64748b",
                              margin: "2px 0 0",
                            }}
                          >
                            AI-powered project structure
                          </p>
                        </div>
                      </div>

                      {/* Button */}
                      <button
                        // onClick={resetForm}
                        style={{
                          padding: "8px 16px",
                          fontSize: "13px",
                          border: "2px solid #cbd5e1",
                          color: "#334155",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() => { resetForm(); setShowProjectDetails(false); }}
                      >
                        Create New Project
                      </button>
                    </div>

                    {/* Original Description */}
                    <div
                      style={{
                        padding: "16px",
                        background: "#eff6ff",
                        borderRadius: "8px",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#334155",
                          margin: 0,
                          lineHeight: "1.6",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#1d4ed8",
                          }}
                        >
                          Original Description:
                        </span>{" "}
                        {aiDescription}
                      </p>
                    </div>
                  </div>
                  {/* ================= HEADER ================= */}

                  {/* ================= PROJECT DETAILS ================= */}
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "16px",
                      boxShadow: "rgba(0, 0, 0, 0.08) 0px 1px 3px",
                    }}
                  >
                    <h3 style={{ margin: "0 0 12px 0", fontSize: "20px" }}>
                      Project Details
                    </h3>

                    <label style={{ fontWeight: 600 }}>
                      Project Name
                    </label>
                    <input
                      value={formData?.project_name || ""}
                      onChange={(e) => updateField("project_name", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        margin: "6px 0 12px",
                        borderRadius: "6px",
                        border: "1px solid #d1d5db",
                      }}
                    />

                    <label style={{ fontWeight: 600 }}>
                      Description
                    </label>
                    <div style={{ position: "relative" }}>

                      <textarea
                        rows={3}
                        value={formData?.description || ""}
                        onChange={(e) => { updateField("description", e.target.value); setDescription(e.target.value); }}
                        style={{
                          width: "100%",
                          padding: "8px",
                          margin: "6px 0 12px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                        }}
                      />
                      <button
                        onClick={handlereAiSuggestion}
                        disabled={aiLoading || loading}
                        style={{
                          position: "absolute",
                          bottom: "20px",
                          right: "8px",
                          height: "32px",
                          padding: "0 14px",
                          borderRadius: "5px",
                          border: "none",
                          background: "linear-gradient(90deg, #8b9cff, #c084fc)",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.75 : 1,
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
                        }} > ✨ AI Suggestion </button>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "8px",
                        marginBottom: "12px",
                        // gap: "12px",
                      }}
                    >

                      <button
                        onClick={handleReGenerate}
                        disabled={aiLoading || reloader}
                        style={{
                          height: "40px",
                          borderRadius: "6px",
                          border: "none",
                          background: "linear-gradient(90deg, #9aa9ff, #c89cff)",
                          color: "#ffffff",
                          fontSize: "15px",
                          fontWeight: 600,
                          cursor: aiLoading || reloader ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "0 16px",
                        }}
                      >
                        ✨ {reloader ? "Generating..." : "Regenerate with AI"}
                      </button>
                    </div>
                    {error && (
                      <p style={{ marginTop: "12px", color: "#dc2626", fontSize: "13px" }}>
                        {error}
                      </p>
                    )}

                    <div style={{ display: "flex", gap: "16px" }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600 }}>
                          Start Date
                        </label>
                        <input
                          type="date"
                          value={formData?.start_date || ""}
                          onChange={(e) => updateField("start_date", e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px",
                            marginTop: "6px",
                            borderRadius: "6px",
                            border: "1px solid #d1d5db",
                          }}
                        />
                      </div>

                      <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600 }}>
                          End Date
                        </label>
                        <input
                          type="date"
                          value={formData?.end_date || ""}
                          onChange={(e) => updateField("end_date", e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px",
                            marginTop: "6px",
                            borderRadius: "6px",
                            border: "1px solid #d1d5db",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* ================= STAGES & TASKS ================= */}
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "16px",
                      boxShadow: "rgba(0, 0, 0, 0.08) 0px 1px 3px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <h3 style={{ margin: 0, fontSize: "20px" }}>
                        Stages & Tasks
                      </h3>

                      <button
                        style={{
                          background: "#2563eb",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                      >
                        + Add Stage
                      </button>
                    </div>

                    {formData?.stages?.map((stage, si) => (
                      <div
                        key={si}
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          marginBottom: "8px",
                        }}
                      >
                        {/* STAGE HEADER */}
                        <div
                          onClick={() => toggleStage(si)}
                          style={{
                            padding: "12px",
                            display: "flex",
                            justifyContent: "space-between",
                            cursor: "pointer",
                            background: "#f9fafb",
                          }}
                        >
                          <div>
                            <strong style={{ fontSize: "13px" }}>
                              {stage?.stage_name}
                            </strong>
                            <p
                              style={{
                                margin: "2px 0 0",
                                fontSize: "11px",
                                color: "#6b7280",
                              }}
                            >
                              {stage?.description}
                            </p>
                          </div>
                          <i
                            className={
                              stage?.open ? "pi pi-chevron-up" : "pi pi-chevron-down"
                            }
                          ></i>
                        </div>

                        {/* TASKS */}
                        {stage?.open && (
                          <div style={{ padding: "12px" }}>
                            {/* TASK HEADER */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns:
                                  "2fr 1.2fr 1.2fr 1fr 40px",
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#374151",
                                marginBottom: "6px",
                              }}
                            >
                              <span>Task Name</span>
                              <span>Start Date</span>
                              <span>End Date</span>
                              <span>Estimated Hours</span>
                              <span></span>
                            </div>

                            {/* TASK ROWS */}
                            {stage?.tasks?.map((task, ti) => (
                              <div
                                key={ti}
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "2fr 1.2fr 1.2fr 1fr 40px",
                                  gap: "8px",
                                  marginBottom: "8px",
                                }}
                              >
                                <input
                                  value={task?.task_name || ""}
                                  onChange={(e) =>
                                    updateTask(si, ti, "task_name", e.target.value)
                                  }
                                  style={{
                                    padding: "6px",
                                    borderRadius: "6px",
                                    border: "1px solid #d1d5db",
                                  }}
                                />

                                <input
                                  type="date"
                                  value={task?.start_date || ""}
                                  onChange={(e) =>
                                    updateTask(si, ti, "start_date", e.target.value)
                                  }
                                  style={{
                                    padding: "6px",
                                    borderRadius: "6px",
                                    border: "1px solid #d1d5db",
                                  }}
                                />

                                <input
                                  type="date"
                                  value={task?.end_date || ""}
                                  onChange={(e) =>
                                    updateTask(si, ti, "end_date", e.target.value)
                                  }
                                  style={{
                                    padding: "6px",
                                    borderRadius: "6px",
                                    border: "1px solid #d1d5db",
                                  }}
                                />

                                <input
                                  type="number"
                                  value={task?.estimated_hours || ""}
                                  onChange={(e) =>
                                    updateTask(
                                      si,
                                      ti,
                                      "estimated_hours",
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    padding: "6px",
                                    borderRadius: "6px",
                                    border: "1px solid #d1d5db",
                                  }}
                                />

                                <span
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "#ef4444",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="pi pi-trash"></i>
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* ================= FOOTER ================= */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                      marginBottom: "0px",
                    }}
                  >
                    <button
                      style={{
                        background: "#f3f4f6",
                        border: "1px solid #d1d5db",
                        padding: "6px 14px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                      onClick={() => { resetForm(); setShowProjectDetails(false); }}
                    >
                      Cancel
                    </button>

                    <button
                      style={{
                        background: "#2563eb",
                        color: "#fff",
                        border: "none",
                        padding: "6px 14px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                       onClick={handleSaveProject}
                    >
                     {saving ? "Saving..." : "Save Project"}
                    </button>
                  </div>
                </div>
              )}


              {stagesview && (
                <div
                  style={{
                    minHeight: "100vh",
                    // background: "#f9fafb",
                    padding: "24px",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "1200px",
                      margin: "0 auto",
                    }}
                  >
                    {/* Header */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <div>
                        <h1
                          style={{
                            fontSize: "28px",
                            fontWeight: 700,
                            margin: 0,
                            color: "#111827",
                          }}
                        >
                          Project Stages
                        </h1>
                        <p
                          style={{
                            marginTop: "4px",
                            color: "#6b7280",
                            fontSize: "14px",
                          }}
                        >
                          Manage your project workflow and team assignments
                        </p>
                      </div>

                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          background: "#2563eb",
                          color: "#fff",
                          border: "none",
                          padding: "10px 16px",
                          borderRadius: "8px",
                          fontWeight: 500,
                          cursor: "pointer",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        }}
                      >
                        + Add Stage
                      </button>
                    </div>
                    {stagesData?.stages?.map((stage) => (
                      <div
                        key={stage.stage_id} // ✅ IMPORTANT FIX
                        style={{
                          border: "2px solid #e5e7eb",
                          borderRadius: "12px",
                          padding: "20px",
                          marginBottom: "16px",
                          background: "#ffffff",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: "16px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700 }}>
                              {stage.stage_name}
                            </h3>
                            <p style={{ marginTop: "6px", color: "#6b7280" }}>
                              {stage.description}
                            </p>
                          </div>

                          <div>
                            <label style={{ display: "block" }}>Team Size</label>
                            <input
                              type="number"
                              min={1}
                              step={1}
                              value={teamSizes[stage.stage_id] ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                // allow empty while typing
                                if (value === "") {
                                  setTeamSizes(prev => ({
                                    ...prev,
                                    [stage.stage_id]: "",
                                  }));
                                  return;
                                }

                                const num = Number(value);
                                if (num > 0) {
                                  setTeamSizes(prev => ({
                                    ...prev,
                                    [stage.stage_id]: num,
                                  }));
                                }
                              }}
                              onWheel={(e) => e.target.blur()}
                              style={{
                                width: "60px",
                                padding: "6px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                marginTop: "4px",
                              }}
                            />

                          </div>
                        </div>
                      </div>
                    ))}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "12px",
                        marginTop: "32px",
                      }}
                    >
                      <button
                        onClick={handleCancelStages}
                        style={{
                          padding: "10px 20px",
                          borderRadius: "8px",
                          border: "1px solid #d1d5db",
                          background: "#ffffff",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        onClick={handleSaveStages}
                        style={{
                          padding: "10px 20px",
                          borderRadius: "8px",
                          border: "none",
                          background: "#2563eb",
                          color: "#ffffff",
                          cursor: "pointer",
                          fontWeight: 500,
                          boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                        }}
                      >
                        Save & Next
                      </button>
                    </div>

                  </div>
                </div>

              )}

            </Col>
          </Row>
        </div>
       {showTeamModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      // background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        width: "460px",
        background: "#ffffff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <div>
          <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>
            Team Members – {selectedStageName?.stage_name}
          </h3>
          <p
            style={{
              margin: "4px 0 0",
              fontSize: "13px",
              color: "#6b7280",
            }}
          >
            Add team members with their roles and experience levels.
          </p>
        </div>

        <button
          onClick={() => setShowTeamModal(false)}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      </div>

      {/* Members Rows */}
      {members.map((member, index) => (
      <div
  key={index}
  style={{
    display: "flex",
    gap: "12px",
    marginBottom: "12px",
    alignItems: "flex-end",
  }}
>
  {/* Role */}
  <div style={{ flex: 1 }}>
    <label style={{ fontSize: "13px", fontWeight: 500 }}>Role</label>
    <input
      type="text"
      value={member.role}
      onChange={(e) =>
        handleMemberChange(index, "role", e.target.value)
      }
      placeholder="e.g., Developer"
      style={{
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
      }}
    />
  </div>

  {/* Experience */}
  <div style={{ flex: 1 }}>
    <label style={{ fontSize: "13px", fontWeight: 500 }}>
      Experience
    </label>
    <input
      type="text"
      value={member.experience}
      onChange={(e) =>
        handleMemberChange(index, "experience", e.target.value)
      }
      placeholder="e.g., 3–5 years"
      style={{
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
      }}
    />
  </div>

  {/* Remove */}
  <button
    onClick={() => handleRemoveMember(index)}
    style={{
      height: "38px",
      width: "38px",
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      background: "#ffffff",
      cursor: members.length === 1 ? "not-allowed" : "pointer",
      color: "#ef4444",
      fontSize: "16px",
    }}
    disabled={members.length === 1}
  >
    ✕
  </button>
</div>

      ))}

      {/* Add Member */}
      <button
        onClick={() =>
          setMembers([...members, { role: "", experience: "" }])
        }
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "none",
          background: "#f3f4f6",
          cursor: "pointer",
          marginBottom: "12px",
        }}
      >
        + Add Member
      </button>
      <button
  onClick={handleSaveTeam}
  style={{
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#111827",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  Save
</button>

    </div>
  </div>
)}


      </Container>
    </React.Fragment>
  );
};

export default Getwithai;
